import { css } from 'styled-components';

export const outer = css`
  border-top: 1px solid var(--neutral-black-30);
  text-align: center;
`;
